import { NarratorNPC } from '../../../../src/feature/narrator/narrator.model';
import { dialog } from './dialog';

export const oakBeggen: NarratorNPC = {
  id: 'oak-beggen',
  name: 'The oak tree',
  dialog: dialog,
};
